/**
 * Optional: nur eine FAQ gleichzeitig geöffnet (data-single-accordion auf .rockfresh-faq)
 */
(function () {
  const root = document.querySelector('.rockfresh-faq[data-single-accordion="true"]');
  if (!root) return;

  root.querySelectorAll('details.rockfresh-faq__item').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      root.querySelectorAll('details.rockfresh-faq__item').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    });
  });
})();
